import { checkSingleSelectedImage, getCanvasResizeInfo, hasSingleSelectedText } from '../../../canvas/selectors';
import {
  getCurrentImprintAreaKey,
  getLogoEditingStatus,
  getSidebarTabKey,
  getStudioItemType,
} from '../../../main/selectors';
import { getStartedIconIdMap, getStartedInCanvasIconIdMap } from '../../constants';

import { createSelector } from 'reselect';

export const getNextgenUiStatus = createSelector(
  (state) => state.nextgenUi,
  (nextgenUi) => nextgenUi
);

export const getStartedIconIds = (state) => {
  const nextgenUiStatus = getNextgenUiStatus(state);
  const getStartedIconList = nextgenUiStatus.getStartedIconList;

  return getStartedIconList?.map((icon) => getStartedIconIdMap[icon]);
};

export const getStartedIconInCanvasIds = (state) => {
  const nextgenUiStatus = getNextgenUiStatus(state);
  const getStartedIconList = nextgenUiStatus.getStartedIconList;
  const startedIconInCanvasIds = getStartedIconList
    ? getStartedIconList.map((icon) => getStartedInCanvasIconIdMap[icon])
    : [''];

  return startedIconInCanvasIds;
};

export const getLeftFlyoutStoreData = createSelector(
  getCurrentImprintAreaKey,
  getStudioItemType,
  getSidebarTabKey,
  checkSingleSelectedImage,
  hasSingleSelectedText,
  getLogoEditingStatus,
  getNextgenUiStatus,
  getCanvasResizeInfo,
  (
    canvasKey,
    studioItemType,
    currentSidebarTabKey,
    hasSingleSeledtImage,
    isSingleSelectedText,
    logoEditingStatus,
    nextgenUiStatus,
    canvasResizeInfo
  ) => {
    return {
      canvasKey,
      studioItemType,
      currentSidebarTabKey,
      hasSingleSeledtImage,
      isSingleSelectedText,
      logoEditingStatus,
      nextgenUiStatus,
      canvasResizeInfo,
    };
  }
);

export const getTransparencyCover = createSelector(
  (state) => state.ui.transparencyCover,
  (transparencyCover) => transparencyCover
);
